// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { formatTime } from '@seedplanner/shared-utils';
import { compareTasks, createCSVContent } from '../../utils';
import type { TaskGroup } from './groupTasks';

function addQuotes(str: string) {
  return `"${str}"`;
}
export const createCSVContentFromTaskGroups = (taskGroups: TaskGroup[], userTimezone: string) => {
  const sorted = [...taskGroups];
  sorted.sort((a, b) => compareTasks(a.tasks[0], b.tasks[0]));

  const data = sorted.map((group) => {
    const tasks = group.tasks;
    const task = tasks[0];
    const cropName = task.crop?.crop_name ?? '';
    const time = formatTime(task.task_time, { timezone: userTimezone });
    const trays = Math.ceil(group.traysNotRounded);
    // Task name, trays, crop name, formatted time, status
    return [task.task_name, trays.toString(), cropName, time, group.isCompleted ? 'Completed' : 'Planned'].map(
      addQuotes,
    );
  });
  const headers = ['Task Name', 'Trays', 'Crop', 'Task Date', 'Status'];
  return createCSVContent({ data: [headers, ...data] });
};
